import * as React from 'react';
import type { AutocompleteProps } from '@mui/material';

export type SelectOption = { label: string; value: string };
export type SelectOptions = ReadonlyArray<SelectOption>;
type SelectValuesSelectedValuesAction = {
    type: 'SELECT_VALUES';
    payload: string[];
};
type DeleteSelectedValueAction = {
    type: 'DELETE_VALUE';
    payload: string;
};
type SelectedValuesAction =
    | SelectValuesSelectedValuesAction
    | DeleteSelectedValueAction;

function selectedValuesReducer(state: string[], action: SelectedValuesAction) {
    switch (action.type) {
        case 'SELECT_VALUES': {
            return action.payload;
        }
        case 'DELETE_VALUE': {
            // $FlowFixMe
            return state.filter((value) => value !== action.payload);
        }
        default: {
            return state;
        }
    }
}

// It returns props for the select based on the provided arguments.
export function useSelectWithCheckboxesProps(
    name: string,
    initialState: string[] | (() => string[]), // We use the items for the options
    options: SelectOptions,
) {
    // Only execute this in initial render.
    const [initial] = React.useState(initialState);
    const [values, dispatch] = React.useReducer(selectedValuesReducer, initial);

    const handleChangeSelect = React.useCallback<
        AutocompleteProps<string, true, false, false>['onChange']
    >(function handleChangeSelect(_event, values) {
        // // FIXME values is an array, but is reported as string
        // const values = event.target.value as string[];
        const newValues = values.filter(
            (value) => value !== null && value !== 'undefined',
        );
        dispatch({ type: 'SELECT_VALUES', payload: newValues });
    }, []);

    const handleDeleteValue = React.useCallback(function handleDeleteValue(
        option: SelectOption,
    ) {
        dispatch({ type: 'DELETE_VALUE', payload: option.value });
    }, []);

    return {
        label: name,
        values,
        options,
        onChange: handleChangeSelect,
        onDeleteValue: handleDeleteValue,
    };
}
